<!-- <h5 class="mt-3 mb-0" translationEditableDirective="LICENSES">
  {{ 'LICENSES' | translate }}
</h5> -->
<div class="pb-4">
  <div class="pb-4 is-flex is-justify-content-end">
    <radio
      [options]="radioOptions"
      [controlled]="true"
      name="dataCycle"
      [value]="dataCycle"
      (onChange)="dataCycleChange($event)"
    ></radio>
  </div>
</div>
<app-tabset *ngIf="!isLoading" (tabChange)="handleTabChange($event)">
  <app-tab [id]="0" name="LICENSES" [active]="activeTab === 0">
    <app-table
      [isLoading]="isLoading"
      [totalItems]="licenses.size"
      [rows]="licenses"
      [columns]="licensesColumns"
      class="mt-4"
      [noDataTemplate]="!!getField(['compound']) ? noDataTemplate : null"
    >
      <ng-template #noDataTemplate>
        <div
          *ngIf="licenses.size === 0 && !isLoading && !!getField(['compound'])"
          class="is-flex py-4 my-4 is-justify-content-center is-align-items-center is-flex-direction-column"
          style="min-height: 250px"
        >
          <p>
            <span translationEditableDirective="NO_DATA_COMPOUND_LICENSE">{{
              'NO_DATA_COMPOUND_LICENSE' | translate
            }}</span>
            <a
              [routerLink]="['/compounds', getField(['compound', 'id'])]"
              class=""
              *ngxPermissionsOnly="['COMPOUNDS']"
            >
              {{ getField(['compound', 'code']) }}
            </a>
            <span *ngxPermissionsExcept="['COMPOUNDS']" class="ml-1">{{
              getField(['compound', 'code'])
            }}</span>
          </p>
          <p translationEditableDirective="NO_DATA_COMPOUND_LICENSE_CHECK">
            {{ 'NO_DATA_COMPOUND_LICENSE_CHECK' | translate }}
          </p>
        </div>
      </ng-template>
      <ng-template let-row="row" #generatedOn>
        <span *ngIf="row.get('generatedOn')">
          {{ row.get('generatedOn') | formatDate }}</span
        >
      </ng-template>
      <ng-template let-row="row" #actionDownload>
        <div style="text-align: right">
          <button
            class="button is-success is-small has-text-white p-0"
            (click)="download(row)"
            translationEditableDirective="DOWNLOAD"
            *ngIf="row.get('generatedOn')"
            style="width: 25px"
          >
            <svg
              width="18px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
            </svg>
          </button>
          <button
            class="button is-warning is-small has-text-white p-0"
            (click)="generate(row)"
            translationEditableDirective="GENERATE"
            *ngIf="!row.get('generatedOn') && !isReadonly"
            [disabled]="isGenerating"
            style="width: 25px"
          >
            <svg
              width="18px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M17,14H19V17H22V19H19V22H17V19H14V17H17V14M12,17V15H7V17H12M17,11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11M17,9V7H7V9H17Z"
              />
            </svg>
          </button>

          <alert
            #deleteAlert
            (confirm)="delete(row)"
            titleTrnKey="ARE_YOU_SURE"
            textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
          />

          <button
            *ngIf="
              !hasReadonlyPermission &&
              !isReadonly &&
              row.get('generatedOn') &&
              row.getIn(['dataCycle', 'id']) == currentDataCycleId
            "
            class="button is-danger is-small p-0 has-text-white ml-2"
            (click)="deleteAlert.fire()"
            translationEditableDirective="DELETE"
            style="width: 25px"
          >
            <svg
              width="18px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M9,8H11V17H9V8M13,8H15V17H13V8Z"
              />
            </svg>
          </button>
        </div>
      </ng-template>
    </app-table>
  </app-tab>
  <app-tab
    *ngFor="let documentType of documentTypes"
    [name]="documentType.get('name')"
    [active]="activeTab === documentType.get('id')"
    [id]="documentType.get('id')"
  >
    <app-table
      [isLoading]="isLoading"
      [totalItems]="
        getDocumentsByType(documentType.get('id'))
          ? getDocumentsByType(documentType.get('id')).size
          : 0
      "
      [rows]="getDocumentsByType(documentType.get('id'))"
      [columns]="columns"
      *ngIf="getDocumentsByType(documentType.get('id')).size"
      [hideFooter]="true"
    >
      <ng-template let-row="row" #createdAt>
        {{ row.get('createdAt') || '' | formatDate }}
      </ng-template>
      <ng-template let-row="row" #actions>
        <div class="buttons" style="justify-content: end">
          <button
            class="button is-success is-small p-0 has-text-white"
            (click)="download(row)"
            translationEditableDirective="DOWNLOAD"
            style="width: 25px"
          >
            <svg
              width="18px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
            </svg>
          </button>
          <alert
            #deleteAlert
            (confirm)="delete(row)"
            titleTrnKey="ARE_YOU_SURE"
            textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS"
          />

          <button
            *ngIf="!hasReadonlyPermission && !isReadonly"
            class="button is-danger is-small p-0 has-text-white"
            (click)="deleteAlert.fire()"
            translationEditableDirective="DELETE"
            style="width: 25px"
          >
            <svg
              width="18px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M9,8H11V17H9V8M13,8H15V17H13V8Z"
              />
            </svg>
          </button>
        </div>
      </ng-template>
    </app-table>

    <div class="no-data">
      <p
        *ngIf="getDocumentsByType(documentType.get('id')).size === 0"
        translationEditableDirective="THERE_IS_NO_DATA_TO_DISPLAY"
      >
        {{ 'THERE_IS_NO_DATA_TO_DISPLAY' | translate }}
      </p>
      <button
        *ngIf="!hasReadonlyPermission && !isReadonly"
        type="button"
        (click)="uploadDocument(documentType.get('id'))"
        class="button is-info"
        translationEditableDirective="UPLOAD_DOCUMENT"
      >
        {{ 'UPLOAD_DOCUMENT' | translate }}
      </button>
    </div>
  </app-tab>
</app-tabset>

<div class="modal is-active" *ngIf="isUploadModalOpen">
  <div class="modal-background"></div>
  <div class="modal-card">
    <div class="modal-card-head">
      <span
        class="modal-card-title"
        translationEditableDirective="UPLOAD_DOCUMENT"
        >{{ 'UPLOAD_DOCUMENT' | translate }}</span
      >
      <button
        class="delete"
        (click)="toggleModal()"
        aria-label="close"
      ></button>
    </div>
    <form class="modal-card-body" [formGroup]="uploadForm">
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="DESCRIPTION">{{
          'DESCRIPTION' | translate
        }}</label>
        <div class="control">
          <input
            class="input"
            name="description"
            type="text"
            formControlName="description"
            [ngClass]="{
              'is-danger':
                uploadForm.get('description')?.invalid &&
                uploadForm.get('description')?.touched
            }"
          />
        </div>
        <p
          class="help is-danger"
          *ngIf="
            uploadForm.get('description')?.invalid &&
            uploadForm.get('description')?.touched
          "
        >
          {{ 'REQUIRED' | translate }}
        </p>
      </div>
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="DOCUMENT">{{
          'DOCUMENT' | translate
        }}</label>
        <div class="control">
          <input
            class="input"
            name="document"
            type="file"
            (change)="documentChange($event)"
            [ngClass]="{
              'is-danger':
                uploadForm.get('file')?.invalid &&
                uploadForm.get('file')?.touched
            }"
          />
        </div>
        <p
          class="help is-danger"
          *ngIf="
            uploadForm.get('file')?.invalid && uploadForm.get('file')?.touched
          "
        >
          {{ 'REQUIRED' | translate }}
        </p>
      </div>
    </form>
    <footer class="modal-card-foot">
      <button
        class="button is-success"
        (click)="upload($event)"
        translationEditableDirective="SAVE"
      >
        {{ 'SAVE' | translate }}
      </button>
      <button
        class="button"
        (click)="toggleModal()"
        translationEditableDirective="CANCEL"
      >
        {{ 'CANCEL' | translate }}
      </button>
    </footer>
  </div>
</div>
